import translations from './translations'

translations.add('es', {
    iAgreeToShareWithClickToPay: (cardBrand) => `Acepto compartir los datos de mi tarjeta, la dirección de facturación y el correo electrónico con ${cardBrand || 'Mastercard' } para inscribirme de forma segura en Click to Pay para realizar pagos más rápidos.`,
    learnMore: 'Más información',
    next: 'SIGUIENTE',
    pay: 'PAGAR',
    submit: 'ENVIAR'
})
